<template>
  <div class="form-step">
    <ion-grid class="form-step-content">
      <ion-row>
        <ion-col>
          <h1 class="form-question">
            What's your best contact number?
          </h1>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <ion-item>
            <ion-input
              inputmode="tel"
              type="tel"
              :value="computedValue"
              @input="computedValue = $event.target.value"
              @keyup.enter="onEnter"
            />
          </ion-item>
        </ion-col>
      </ion-row>
      <ion-row v-if="message">
        <ion-col>
          <slot name="invalid">
            <ion-chip color="danger">
              <ion-label>{{ message }}</ion-label>
            </ion-chip>
          </slot>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</template>

<script>
export default {
  name: "StepPhone",
  props: ["value", "data", "message"],
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    onEnter() {
      this.$emit("next");
    }
  }
};
</script>
